import store from "../store";
// import {addGetParameters, setUrlParameters} from "./index";
import {addGetParameters, loadData, setUrlParameters} from "@/helper/requests";

// import {loadData} from "./index";

export function makeMediaHostUrl(host, url) {
  /**
   * Функция формирует полный URL медиа-файла путем объединения хоста и пути.
   * @param {string} host - Базовый хост медиа-сервера
   * @param {string} url - Относительный путь к медиа-файлу
   * @returns {string} Полный URL медиа-файла
   */
    return host + url
}

export function getUrl(host, base, urlname, action) {
    let url = store.getters['urls/getPattern'](
        base,
        urlname,
        action
    );
    if (url !== '')
        return host + url;
    else
        return ''

}

export function getUrlAllowed(base, urlname, action) {
  /**
   * Проверяет, разрешено ли выполнение указанного действия по данному URL.
   * @param {string} base - Базовый модуль или префикс URL
   * @param {string} urlname - Имя или шаблон URL
   * @param {string} action - Действие для проверки (например, 'get', 'post', 'delete')
   * @returns {boolean} true если действие разрешено, false если запрещено
   */
    return store.getters['urls/getAllowed'](
        base,
        urlname,
        action
    );
}

export function checkUrlAllowedWithParameters(host, base, urlname, action, pars) {
  /**
   * Проверяет, разрешено ли выполнение указанного действия по данному URL с дополнительными параметрами.
   * @param {string} base - Базовый модуль или префикс URL
   * @param {string} urlname - Имя или шаблон URL
   * @param {string} action - Действие для проверки (например, 'get', 'post', 'delete')
   * @param {string} pars - Дополнительные параметры
   * @returns {boolean} true если действие разрешено, false если запрещено
   */
    let checks = [{
        name: urlname,
        parameters: pars
    }]
    loadData(`${host}/instance/named/url/parametrize/list/allowed/?urls=${JSON.stringify(checks)}`, (data) => {})
}

export function getUrlWithParameters(host, base, urlname, action, parameters = {}, get_parameters = null) {
  /**
   * Формирует полный URL с параметрами для API запроса.
   * @param {string} host - Базовый хост API сервера
   * @param {string} base - Модуль или префикс API (например, 'users', 'products')
   * @param {string} urlname - Имя конкретного endpoint'а или ресурса
   * @param {string} action - HTTP метод или действие ('get', 'post', 'put', 'delete')
   * @param {Object} [parameters={}] - Параметры для подстановки в path URL (например, {id: 123})
   * @param {Object} [get_parameters=null] - Query параметры для добавления в URL (?key=value)
   * @returns {string} Полный сформированный URL с параметрами
   */
    let url = setUrlParameters(
        getUrl(
            host,
            base,
            urlname,
            action
        ),
        parameters
    );
    if (get_parameters !== null) {
        return addGetParameters(url, get_parameters);
    }
    return url
}

